<template>
    <div class="privacy">
        <p class="center bold">可瀚学堂用户隐私保护政策</p>
        <p>版本更新日期：2021年8月19日<br>版本生效日期：2021年8月19日</p>
        <p>介绍</p>
        <p>公司名称：深圳格熙信息科技有限公司<br>
注册地址：深圳市龙岗区龙城街道黄阁路天安数码城3栋B座4楼F26<br>
个人信息保护联系方式：business@kehigh.com</p>
        <p class="bold">我们重视未成年人的个人信息保护，如您为未成年人，请您的监护人仔细阅读本隐私政策，并在您的监护人协助下进行注册或登录，请在已经征得您的监护人同意后使用我们的服务或向我们提供信息。</p>
        <p class="bold">深圳格熙信息科技有限公司尊重并保护用户隐私，在您使用可瀚学堂提供的服务时，我们将按照<span class="blue">《可瀚学堂用户隐私保护政策》</span>（以下简称“本隐私政策”）收集、使用及共享您的个人信息。
本隐私政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，我们希望通过本隐私政策向您清晰地介绍我们对您个人信息的处理方式，因此我们建议您完整地阅读本隐私政策，以帮助您了解维护自己隐私权的方式。如果您不同意本隐私政策任何内容，您应立即停止使用可瀚学堂产品或服务。当您使用可瀚学堂提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。</p>
        <p>一、适用范围</p>
        <p>本隐私政策适用于可瀚学堂提供的所有服务，您访问可瀚学堂网站、客户端，均适用本隐私政策。</p>
        <p>二、我们收集哪些信息</p>
        <p>为了向您提供更好、更优、更个性化的服务，我们将根据您使用的服务收集您的如下信息：</p>
        <p>您向我们提供的信息。您在注册账户时向我们提供的相关个人信息，（包括电话号码、姓名、班级、学科、年级、性别）；为确认教师身份而提交的教师资格证件信息；我们还会记录您在使用我们服务时提供的信息，您在可瀚学堂客户端发布的信息、与可瀚学堂客服联系时您提供的相关信息、您参与问卷调查时向我们发送的问卷答复信息、向您寄送礼品或资料时您提供的收取快递地址及电话。</p>
        <p>在您使用服务过程中产生的信息。我们会根据您授予的权限，接收并记录您所使用的设备相关信息，这些设备信息包括：设备信息(包括IMEI、设备序列号、OAID、MEID、Android ID、IMSI、GUID、ICCID、MAC地址、SIM卡序列号)、已安装APP信息或运行中进程信息、设备所在位置相关信息（IP地址、GPS/北斗位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）这些信息包括：设备型号，设备名称，操作系统版本，唯一设备识别码，登录ip地址，MAC地址，网络接入方式（WiFi，3G，4G，5G等），网络质量数据，运营商名称或简称，当前应用程序的版本信息，屏幕尺寸以及未来可能用到的位置信息等；
        <p>为满足用户使用服务的需求而获取设备权限：允许程序读写设备外部存储空间(内置SDcard和外置SDCard)、麦克风权限、相册和拍照权限；</p>
        <p>为满足用户使用服务的需求而获取设备权限：麦克风权限、相册和拍照权限；</p>
        <p>三、我们如何收集信息</p>
        <p>(1)通过注册或活动邀请，收集、保存您在使用我们产品的各项服务功能时所提交的信息，包括电话、姓名、班级、地址、年级、性别，及教师用户提供的教师资格证等证件信息；</p>
        <p>(2)我们通过授权的系统权限收集您的设备信息、位置信息，并将该等信息储存为日志信息，记住您的身份。</p>
        <p>(3)我们会通过web请求来收集您的IP地址</p>
        <p>四、我们如何使用收集到的信息</p>
        <p>收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：</p>
        <p>(1)向您提供您使用的各项服务，并维护、改进这些服务。</p>
        <p>(2)我们可能使用您的个人信息以预防、发现、调查涉及欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、我们的其他用户、我们或我们关联方的合法权益。</p>
        <p>(3)我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、内容和建议。</p>
        <p>(4)通过程序读写设备外部存储空间权限，以获取可瀚学堂APP存储的根文件夹下的资料，用于用户设置、作业记录、配音缓存等功能</p>
        <p>(5)通过麦克风权限，以获取您的授权使用的音频信息，以便在学习功能（如逐句跟读、长段背诵等功能）中使用；</p>
        <p>(6)通过相册权限，以获取您的授权使用的图片或视频资料，以便在上传头像、上传视频和修改头像等功能中采集相关图片和视频；</p>
        <p>(7)通过相机权限，以获取您的授权使用的图片或视频资料，以便在拍照时上传头像、上传视频和个性化使用（如修改头像）等功能中采集相关图片和视频；</p>
        <p>(8)您在可瀚学堂旗下平台上主动发布内容（如上传表演视频）时，平台将收集您发布的信息，并在平台上展示您的昵称、头像、上传时间和发布的视频等；</p>
        <p>(9)我们可利用设备属性信息来了解您使用我们的服务进行什么活动，或哪些服务最受您的欢迎；</p>
        <p>(10)记录设备属性信息，用于标记用户身份，提供产品服务和内容；</p>
        <p>(11)设备位置信息，用于根据您所在地域向您推荐课程、内容等功能；</p>
        <p>(12)经您许可的其他用途。但无论如何，我们仅在本隐私政策所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</p>
        <p>五、我们可能分享的信息</p>
        <p>除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：我们以及我们的关联公司，可能将您的个人信息与我们的关联公司合作伙伴及第三方服务供应商、承包商及代理分享（他们可能并非位于您所在的法域），用作下列用途：</p>
        <p>1.向您提供我们的服务，包括但不限于邮件、短信等信息推送服务，使用第三方地图服务；</p>
        <p>2.实现“我们如何使用收集到的信息”部分所述目的；</p>
        <p>3.履行我们在本隐私政策或可瀚学堂其他产品的用户协议中的义务和行使我们的权利；</p>
        <p>4.理解、维护和改善我们的服务。</p>
        <p>如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该第三方在使用您的个人信息时遵守本隐私政策及我们要求其遵守的其他适当的保密和安全措施。随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
        <p>(1)遵守适用的法律法规；</p>
        <p>(2)遵守法院命令或其他法律程序的规定；</p>
        <p>(3)遵守相关政府机关的要求；</p>
        <p>为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
        <p>5.为保障可瀚学堂APP相关功能的实现与应用的安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。通过大数据的分析等途径分析、了解使用者的需求，设计新的商业模式，评估和改进我们的服务，提升用户体验等。任何该等共享均受保密和安全保障责任限制。我们会对第三方合作伙伴获取信息的软件工具开发包（SDK详情见下述列表）进行严格的完全检测，以保证数据安全，我们的第三方合作伙伴无权将共享的个人信息用于任何其他用途。下面是涉及收集用户信息的第三方SDK及用途说明：</p>
        <p>   （1）友盟统计SDK<br/>
            使用目的：提供统计分析服务<br/>
            收集个人信息类型：设备Mac地址、唯一设备标识码(IMEl/AndroidID/IDFA/OPENUDID/GUID、SIM 卡IMSI 信息)、设备序列号<br/>
            隐私权政策链接：https://www.umeng.com/policy<br/>
            提供方：友盟同欣（北京）科技有限公司</p>

        <p>   （2）友盟社会化分享<br/>
           使用目的：用于帮助用户将信息分享至第三方应用<br/>
           收集个人信息类型：设备标识符、Wi-Fi地址<br/>
           隐私权政策链接：https://www.umeng.com/policy<br/>
           提供方：友盟同欣（北京）科技有限公司</p>

        <p>    （3）微博分享<br/>
            使用目的：用于将您感兴趣的内容分享至新浪微博<br/>
            收集个人信息类型：设备标识信息<br/>
            隐私权政策链接：https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3<br/>
            提供方：北京微梦创科网络技术有限公司</p>

        <p>    （4）微博账号登录<br/>
            使用目的：用于微博联合登录<br/>
            收集个人信息类型：设备标识符、Wi-Fi地址<br/>
            隐私权政策链接：https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3<br/>
            提供方：北京微梦创科网络技术有限公司</p>

        <p>    （5）微信登录<br/>
            使用目的：用于微信联合登录<br/>
            收集个人信息类型：设备标识符、Wi-Fi地址<br/>
            隐私权政策链接：https://weixin.qq.com/cgi-bin/readtemplate?spm=a1zaa.8153814.0.0.67abe7a3ddAz0R&lang=zh_CN&t=weixin_agreement&s=privacy<br/>
            提供方：深圳市腾讯计算机系统有限公司</p>

        <p>    （6）微信分享<br/>
            使用目的：用于将您感兴趣的内容分享至微信<br/>
            收集个人信息类型：设备标识信息<br/>
            隐私权政策链接：https://weixin.qq.com/cgi-bin/readtemplate?spm=a1zaa.8153814.0.0.67abe7a3ddAz0R&lang=zh_CN&t=weixin_agreement&s=privacy<br/>
            提供方：深圳市腾讯计算机系统有限公司</p>

        <p>    （7）QQ登录<br/>
            使用目的：用于QQ联合登录<br/>
            收集个人信息类型：设备标识符、Wi-Fi地址<br/>
            隐私权政策链接：https://privacy.qq.com/<br/>
            提供方：深圳市腾讯计算机系统有限公司</p>

        <p>    （8）QQ分享<br/>
            使用目的：用于将您感兴趣的内容分享至QQ<br/>
            收集个人信息类型：设备标识信息<br/>
            隐私权政策链接：https://privacy.qq.com/<br/>
            提供方：深圳市腾讯计算机系统有限公司</p>

        <p>    （9）UC啄木鸟<br/>
            使用目的：受委托提供APP内H5性能问题定位分享服务<br/>
            收集个人信息类型：可能会调取用户的设备信息（含系统版本、机型、运营商等）<br/>
            隐私权政策链接：https://open-uc.uc.cn/agreement/secret<br/>
            提供方：优视科技（中国）有限公司</p>

        <p>    （10）百度定位SDK<br/>
            使用目的：用于获取位置信息<br/>
            收集个人信息类型：可能会调取用户位置信息、存储（写入离线定位数据）<br/>
            隐私权政策链接：https://lbsyun.baidu.com/index.php?title=open/privacy<br/>
            提供方：北京百度网讯科技有限公司</p>

        <p>    （11）讯飞语音SDK<br/>
            使用目的：用于语音评测、识别、合成<br/>
            收集个人信息类型：可能会调取用户的唯一设备识别码、已安装APP信息、麦克风、存储、用户音频<br/>
            隐私权政策链接：https://www.xfyun.cn/doc/policy/privacy.html<br/>
            提供方：科大讯飞股份有限公司</p>

        <p>    （12）腾讯bugly SDK<br/>
            使用目的：为提高服务稳定性，便于相关服务崩溃后快速准确定位存在问题<br/>
            收集个人信息类型：Crash环境（Crash信息及线程堆栈，ROM/RAM/SD卡容量、网络/语言状态App信息：包名、版本、所属进程）、已安装APP信息、设备信息(AndroId、ICCID)、设备厂商、设备名称、操作系统版本、运营商代码，App运行状态，闪退、卡顿、网络信息、日志信息<br/>
            隐私权政策链接：http://bugly.qq.com/v2/contract<br/>
            提供方：深圳市腾讯计算机系统有限公司</p>

        <p>    （13）Facebook SDK<br/>
            使用目的：用于将您感兴趣的内容分享至Facebook<br/>
            收集个人信息类型：设备标识信息<br/>
            隐私权政策链接：https://www.facebook.com/privacy/explanation</p>

            <!--table border="1" class="sdk">
                <tr>
                    <th colspan="3">SDK详情</th>
                </tr>
                <tr>
                    <th>SDK名称</th>
                    <th>调用的权限或用户信息</th>
                    <th>作用范围及目的</th>
                </tr>
                <tr>
                    <td>讯飞语音评测SDK</td>
                    <td>使用权限：访问网络、获取网络状态信息，访问麦克风录音，读取系统日志，写入外部存储，麦克风权限、使用储存权限，获取WiFi状态，读取电话状态</td>
                    <td>用于语音评测</td>
                </tr>
                <tr>
                    <td>友盟SDK</td>
                    <td>调取设备识别信息、设备MAC地址、设备运行进程信息、地理位置信息、崩溃日志、品牌、型号</td>
                    <td>用于应用内事件上报、统计</td>
                </tr>
                <tr>
                    <td>百度定位SDK</td>
                    <td>调取设备标识信息IMEI、位置信息（IP地址）、所有基站定位信息、设备MAC地址、存储（写入离线定位数据）</td>
                    <td>用于获取位置信息</td>
                </tr>
                <tr>
                    <td>UC啄木鸟</td>
                    <td>调取用户的设备信息（含系统版本、机型和运营商等）崩溃日志、设备MAC地址、IP地址</td>
                    <td>用于崩溃信息收集</td>
                </tr>
            </table-->
        <p>六、您如何管理自己的信息</p>
        <p>我们提供了便捷的方法，让您可以查询、更正及删除自己的账户信息等使用我们服务时您提供的个人信息。</p>
        <p>1、访问您的个人信息：打开可瀚学堂学生App，进入“我的”----点击“个人头像”，即可访问您的个人信息</p>
        <p>2、更正或者补充您的个人信息：打开可瀚学堂学生App，进入“我的”----点击“个人头像”即可编辑您的个人信息</p>
        <p>3、删除您的个人信息：如您需要删除个人信息，请您拨打17796327580，客服将通过系统后台于3个工作日内删除您的个人信息</p>
        <p>4、撤回或改变您的授权： 如需撤回或改变您的授权，也需通过拨打17796327580客服电话，可瀚学堂将视为您放弃使用可瀚学堂相关产品，并为您进行删除账号及有关信息的处理</p>
        <p>5、用户账号注销：如您需要注销个人账号，请您拨打17796327580，告知客服注销原因后，客服将通过系统后台于3个工作日内注销您的账号。</p>
        <p>如果您认为我们存在违反法律、行政法规的规定或者违反与您的约定而收集、使用您个人信息的，您可以拨打17796327580或发送邮件至business@kehigh.com通过可瀚学堂客服与我们取得联系，我们将在15工作日以内回复处理意见或结果。</p>
        <p>七、您的个人信息保护</p>
        <p>我们将您的信息存储在leancloud云服务器上，并且leancloud机器均处在中国大陆境内。</p>
        <p>我们将不提供个人信息出境的转发。</p>
        <p>我们非常重视您的个人信息安全。我们有专门的安全部门负责保护您的个人信息。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于采取信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。</p>
        <p>可瀚学堂账户信息（包括网站及客户端账号名、密码信息）为非常重要的个人信息，请您妥善设置、保管您的账号名及密码信息。我们将通过备份、对密码进行加密等安全措施以保护您的账户信息等个人信息不丢失、不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。请注意，单独的设备信息等是无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将这类非个人信息与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类设备信息将被视为个人信息。</p>
        <p>八、未成年人保护</p>
        <p>对于经监护人同意使用我们的服务而向我们提供信息未成年人，我们只会在法律法规允许或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
        <p>如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。</p>
        <p>九、商业信息</p>
        <p>我们可能使用您的相关信息，向您提供与您更加相关的商业信息。我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送商业信息，提供或推广我们的商品或服务。如您不希望我们将您的个人信息用作前述商业用途，您可以可以拨打17796327580或发送邮件至business@kehigh.com通过可瀚学堂客服与我们取得联系。</p>
        <p>十、我们可能向您发送的邮件和信息</p>
        <p>邮件和信息推送。您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。</p>
        <p>与服务有关的公告。我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
        <p>基本政策的修订。我们可不定期修改本隐私政策，变更后的隐私政策将在修订生效前通过可瀚学堂平台公告或以其他适当方式通知您。该等情况下，若您继续使用我们的服务，即表示同意受经修订的隐私政策的约束。</p>
    </div>
</template>

<script>
export default {
    created(){
        document.title = '可瀚学堂用户隐私保护政策'
    }
}
</script>

<style scoped lang='scss'>
    .privacy{
        margin: 0 26px 0 19px;
        padding-bottom: 50px;
        color: #7a7988;
        font-size: 15px;
        & > p {
            margin-top: 22px;
            line-height: 20px;
        }
        .bold{
            font-weight: bold;
        }
        .blue{
            color: #24b8fe;
        }
        .center{
            text-align: center;
        }
        .sdk{
            font-size: 10px;
        }
    }
</style>
